import { HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr';

/**
 *
 * This will be removed, as we have introduced the connection hub manager, more robust and appropriate approach.
 * once testing is done on notification hub, we will remove this. and replace with the connection hub manager in all the places.
 */
export const useHubConnection = () => {
  return new HubConnectionBuilder()
    .withUrl('/progressHub')
    .withAutomaticReconnect()
    .build();
};

export const useConnectHub = async (connection, callbackMethod) => {
  if (connection.state === HubConnectionState.Disconnected) {
    connection
      .start()
      .then(() => {
        callbackMethod();
      })
      .catch((err) => {
        console.error('Error establishing connection:', err);
      });
  }
};

export const useDisconnectHub = () => {
  return (connection) => {
    if (connection.state === HubConnectionState.Connected) {
      connection.stop();
    }
  };
};
